import { RJSFSchema, StrictRJSFSchema, WidgetProps } from '@rjsf/utils';

import Radio from 'design-system/components/Radio';
import RadioGroup from 'design-system/components/RadioGroup';

/** The `RadioWidget` is a widget for rendering a radio group.
 *  It is typically used with a string property constrained with enum options.
 *
 * @param props - The `WidgetProps` for this component
 */
export function RadioWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F = any>({
  options,
  value,
  required,
  disabled,
  readonly,
  autofocus = false,
  onChange,
  id,
}: /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
WidgetProps<T, S, F>) {
  const { enumOptions, enumDisabled, inline } = options;

  return (
    <RadioGroup id={id} horizontal={inline} onChange={onChange} value={value}>
      {Array.isArray(enumOptions) &&
        enumOptions.map((option, i) => {
          const itemDisabled =
            Array.isArray(enumDisabled) && enumDisabled.indexOf(option.value) !== -1;

          return (
            <Radio
              key={option.label}
              label={option.label}
              required={required}
              value={option.value}
              disabled={disabled || itemDisabled || readonly}
              autoFocus={autofocus && i === 0}
            />
          );
        })}
    </RadioGroup>
  );
}
